<script setup>
/* Props */
const props = defineProps({
  content: {
    type: String,
    default: '',
  },
});
</script>

<template>
  <g-copy
    id="js__product__marketing-summary"
    class="app__product__marketing-summary"
    type="small"
    v-html="props.content"
  />
</template>
